// src/axios.js

import axios from 'axios';
import tracker from './utils/tracker';
import { BASE_URL } from './config';

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 添加 token 或其他请求头处理
    const token = localStorage.getItem('Authorization');
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 处理成功的响应
    return response;
  },
  (error) => {
    // 处理错误的响应
    if (error.response) {
      // 服务器响应了，但状态码不在 2xx 范围内
      switch (error.response.status) {
        case 500:
          // 处理 500 错误
          break;
        default:
          // 处理其他错误
      }
      
      // 埋点：记录接口错误信息，但排除未登录错误（code: 5000）
      const responseData = error.response.data;
      if (!(error.response.status === 500 && responseData && responseData.code === 5000 && responseData.message === '请先登录')) {
        tracker.trackError(error.message, {
          status: error.response.status,
          statusText: error.response.statusText,
          url: error.config.url,
          method: error.config.method,
          data: error.config.data,
          responseData: responseData
        });
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      
      // 埋点：记录请求超时或无响应错误
      tracker.trackError(error.message, {
        url: error.config.url,
        method: error.config.method,
        data: error.config.data
      });
    } else {
      // 发生在设置请求时的错误
      
      // 埋点：记录请求设置错误
      tracker.trackError(error.message);
    }
    // 返回原始错误对象
    return Promise.reject(error);
  }
);

export default instance;